export default __webpack_public_path__ + "static/media/section2-guide-bar-h5.35f0f84e.png";